// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"122":"20587d50","188":"3ba95f45","277":"5d0c228e","488":"3eabe148","525":"7221ae37","619":"e2140844"}[chunkId] + ".chunk.js";
};